import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RecruitmentActivitiesDto } from "./recruitment-activities-dto";

export class RecruitmentActivitiesResponse extends GlobalResponseObject{
    data?: RecruitmentActivitiesDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: RecruitmentActivitiesDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}